module.exports = __webpack_public_path__ + "static/media/partnerships-bg.c575a53f.jpg";